import { cn } from '@ui/lib';
import React, { ReactElement } from 'react';
import { BaseButtonProps } from './buttonConfig';

export interface ButtonContainerProps<T extends BaseButtonProps> {
  children:
    | ReactElement<T>
    | [ReactElement<T>]
    | [ReactElement<T>, ReactElement<T>];
  outsidePadding?: boolean;
  sideBySide?: boolean;
  className?: string;
}

export const ButtonContainer = <T extends BaseButtonProps>({
  children,
  outsidePadding = false,
  sideBySide = false,
  className,
}: ButtonContainerProps<T>) => {
  return (
    <div
      className={cn('button-container', className)}
      data-outside-padding={outsidePadding ? 'true' : 'false'}
      data-side-by-side={sideBySide ? 'true' : 'false'}
    >
      {React.Children.map(children, (child) =>
        React.cloneElement(
          child as ReactElement<T>,
          { sticky: sideBySide } as Partial<T>,
        ),
      )}
    </div>
  );
};
